import React from "react";
import { CompanyForContactDetails } from "./CompanyForContactDetails";

interface Props {
  worksAt: server.dto.CompanyWithWorkRelation[]
}

export const ContactWorksAtSection = ({ worksAt }: Props) => {
  if (worksAt.length === 0) {
    return null;
  }

  return <div className="flex-column gap">
    <div className="nav-text-regular">{RESX.GeneralLabels.WorksAt}</div>
    {worksAt.map(companyWithWorkRelation => <CompanyForContactDetails key={companyWithWorkRelation.company.companyId} company={companyWithWorkRelation} />)}
  </div>
}